<template>
  <li :class="getClass()">
    <router-link :to="{path: linkValue}" v-if="internalLink">
      <img :src="imgSrc ? 'https://apps.odenserundt.dk/media/images/480/'+imgSrc : '/img/placeholder.png'" class="recommended-box-img" :alt="'Billede af '+childData.title" :aria-label="'Billede af '+childData.title"/>
      <div class="theme-box-text-div">
        <div class="recommended-box-text-div"><strong>{{ childData.title }}</strong><br><span>{{ childData.desc }}</span></div>
      </div>
    </router-link>
    <a :href="linkValue" v-else>
      <img :src="imgSrc ? 'https://apps.odenserundt.dk/media/images/480/'+imgSrc : '/img/placeholder.png'" class="recommended-box-img" :alt="'Billede af '+childData.title" :aria-label="'Billede af '+childData.title"/>
      <div class="theme-box-text-div">
        <div class="recommended-box-text-div"><strong>{{ childData.title }}</strong><br><span>{{ childData.desc }}</span></div>
      </div>
    </a>

    <!-- <button class="btn-reset like-icon" :aria-label="[isLiked ? 'Fjern '+childData.title+' fra favoritter' : 'Tilføj '+childData.title+' til favoritter']" @click="likeController" tabindex="0">
      <span :class="['material-icons', 'like-icon-i', {'pink-text' : isLiked}]" aria-hidden="true">favorite_border</span>
    </button> -->
  </li>
</template>

<script>

import Dato from '@/assets/Dato.js'
import DataManager from '@/assets/DataManager.js'
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      linkValue: '',
      internalLink: true,
      imgSrc: false,
      likeImage: false,
      itemId: '',
      isLiked: false,
      isInGroup: false,
    }
  },
  props: {
    childData: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object
    },
    searchDataExpanded: {
      type: Array
    },
    index: {
      type: Number,
      required: true
    }
  },
  created() {
    this.getImage();

    //Create link value
    if(this.$props.childData.type == 'link') {
      if(this.$props.childData.link.indexOf('odenserundt.dk') != -1) {
        let split = this.$props.childData.link.split('odenserundt.dk');
        this.linkValue = split[1];
      }
      else {
        this.internalLink = false;
        this.linkValue = this.$props.childData.link;
      }
      this.itemId = this.childData.id;
      this.likeOptions = {type: this.childData.type, id: this.childData.id, name: this.childData.title, http: this.childData.link};
    }
    if(this.$props.childData.type == 'group') {
      this.linkValue = '/group/'+this.$props.childData.id;
      this.itemId = this.childData.id;
      this.likeOptions = {type: this.childData.type, id: this.childData.id, name: this.childData.title};
    }
    if(this.$props.childData.type == 'tag') {
      this.linkValue = '/tag/'+this.$props.childData.tag_id;
      this.itemId = this.childData.tag_id;
      this.likeOptions = {type: this.childData.type, id: this.childData.tag_id, name: this.childData.title};
    }
    if(this.$props.childData.type == 'place') {
      var placeTag = this.searchDataExpanded.find(obj => obj.placeId == this.$props.childData.item_id);
      this.linkValue = '/tag/'+placeTag.tagId+'/place/'+this.$props.childData.item_id;
      this.likeOptions = {type: this.childData.type, id: this.childData.item_id, name: this.childData.title, tagId: placeTag.tagId};
      this.itemId = this.childData.item_id;
    }

    if(Profile.loggedIn) {
      this.isLiked = Profile.checkIfItemIsLiked(this.childData.type, this.itemId);
    }
  },
  methods: {
    likeController() {
      if(Profile.loggedIn) {
        var isLiked = Profile.checkIfItemIsLiked(this.type, this.id);
        if(!isLiked) {
          //Add image src now because it might not be ready when options are first made.
          this.likeOptions.img = this.imgSrc;
          Profile.like(this.likeOptions);
          this.isLiked = true;
        }
        else if(isLiked) {
          var obj = {message: 'Vil du fjerne '+this.name+' fra dine favoritter?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.unlikeDone};
          EventBus.$emit('openMessageBox', obj);
        }
      }
      else {
        this.$router.push('/login');
      }
    },
    unlikeDone() {
      Profile.unlike(this.type, this.id);
      this.isInGroup = Profile.checkIfItemIsInUserGroup(this.childDatatype, this.itemId);
      this.isLiked = false;
    },

    getClass(index) {
      var className = 'default';
      if(this.index == 0 || this.index == 1 || this.index == 5 || this.index == 6 || this.index == 10 || this.index == 11) {
        className = 'col col-lg-6 col-md-6 col-sm-6 col-12 recommended-box';
      }
      else {
        className = 'col col-lg-4 col-md-4 col-sm-6 col-12 recommended-box';
      }
      return className;
    },

    getImage() {
      var expired = false;
			//console.log(kids[k]);
			if(this.$props.childData.endDate != false) {
				var itemExpired = Dato.checkExpireDate(this.$props.childData);
				expired = (itemExpired) ? false : true;
			}

  		if(!expired) {
        if(this.$props.childData.type == 'place') {
    			var tempImage = false;
          var placeTag = this.searchDataExpanded.find(obj => obj.placeId == this.$props.childData.item_id);
          //console.log(placeTag);
          if(placeTag != undefined) {
    				this.linkValue = 'tag/'+placeTag.tagId+'/place/'+this.$props.childData.item_id;
            DataManager.getData([DataManager.newTags+placeTag.tagId+'-dk-light.json'], (response) => {
              var item = response[0].data.features.find(obj => obj.id == this.$props.childData.item_id);
              //Check for temp image
    					if(item.properties.prop117 && item.properties.prop108) {
    						if(item.properties.prop117.value != null && item.properties.prop117.value != undefined && item.properties.prop117.value != 0) {
    							var from = new Date(item.properties.prop117.value.from);
    							var to = new Date(item.properties.prop117.value.to);
    							if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()) {
    								this.imgSrc = item.properties.prop108.value[0].src;
    								tempImage = true;
    							}
    						}
    					}
    					if(item.properties.prop25 && !tempImage) {
    						this.imgSrc = item.properties.prop25.value[0].src;
    					}
            });
    			}
    		}
    		if(this.$props.childData.type == 'group' || this.$props.childData.type == 'link') {
    			if(this.$props.childData.media != '' && this.$props.childData.media != 0 && this.$props.childData.media != null && this.$props.childData.media != false) {
    				this.imgSrc = this.$props.childData.media;
    			}
    		}
        else if(this.$props.childData.type == 'tag') {
    			if(this.tagList[this.$props.childData.tag_id]) {
    				if(this.tagList[this.$props.childData.tag_id].image) {
    					if(this.tagList[this.$props.childData.tag_id].image != 0 && this.tagList[this.$props.childData.tag_id].image != "" && this.tagList[this.$props.childData.tag_id].image != null && this.tagList[this.$props.childData.tag_id].image != false) {
                this.imgSrc = this.tagList[this.$props.childData.tag_id].image;
    					}
    				}
    			}
        }
      }
  	},
  },
}
</script>

<style lang="scss" scoped>
  .recommended-box {
    display: inline-block;
    position: relative;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 10px;
  }

  /*Landscape - XS*/
  @media screen and (max-width: 767px) and (orientation: landscape) {
    .recommended-box {
      max-width: 50%;
    }
  }
  /*Landscape - MD*/
  @media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
    .recommended-box {
      margin-top: 10px;
    }
  }
  /*Landscape - LG*/
  @media screen and (min-width: 1200px) and (orientation: landscape) {
    .recommended-box {
      margin-top: 10px;
    }
  }
  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
    .recommended-box {
      height: auto !important;
      padding: 0px;
      margin-bottom: 10px;
    }
    /*Iphone 5 fix*/
    @media screen and (max-width: 320px) {
      .recommended-box {
        margin-top: 10px;
      }
    }
    /*Iphone 6 fix*/
    @media screen and (min-width: 376px) and (max-width: 415px) {
      .recommended-box {
        margin-top: 10px;
      }
    }
  }
  /*Portrait - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
    .recommended-box {
      margin-top: 20px;
    }
  }

  .recommended-box-img {
    width: 100%;
    -webkit-filter: grayscale(10%);
    filter: grayscale(10%);
  }

  .recommended-box-text-div {
    height: 80px;
    width: 100%;
    color: #424242 !important;
    padding: 5px 5px 5px 5px;
    letter-spacing: 0.5px;
    background-color: #fdfdfd;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  }

  .recommended-box-text-div span {
    display: block;
    line-height: 17px;
  }

</style>
